import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const PollResultsNotificationCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  const content = rtl ? `نتائج التصويت` : `Your Voting Results are ready`
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={content}
    />
  )
}

export default PollResultsNotificationCover
